import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import UnavailableSupport from '../components/UnavailableSupport';

import { browserHistory } from 'react-router';

export class UnavailableLoginPage extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { auth: { status } } = this.props;

    if (status === 'up') {
      browserHistory.push('/');
    }
  }

  render() {
    return (
      <div className="bg-dots page-header-dots">
        <div className="container">
          <UnavailableSupport withBorder withImage />
        </div>
      </div>
    );
  }
}

UnavailableLoginPage.propTypes = {
  auth: PropTypes.object
};

const mapStateToProps = state => ({ auth: state.auth });

export default connect(mapStateToProps)(UnavailableLoginPage);
